
import cx from 'classnames';
import styles from './index.module.scss';
import SignIn from '../../assets/icon/recommand/signIn.svg';

const SignInTooltip: React.FC<{
  message: string;
  visible: boolean,
  className?: string, // 在使用的地方控制定位可以使用
}> = ({ message, visible, className = '' }) => {
  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        display: visible ? 'flex' : 'none',
      }}
      className={cx(styles.signInTooltip, className)}
    >
      <div className={styles.icon}>
        <SignIn />
      </div>
      <div className={styles.message}>
        {message}
      </div>
    </div>
  );
};

export default SignInTooltip;
